const GET_A_QUOTE_URL = '/Health-Insurance/Get-a-Quote';
const JOIN_NOW_URL = `${GET_A_QUOTE_URL}/Join-Now`;

export const PageURLs = Object.freeze({
  API_ERROR_PAGE: '/error/api-error',
  NOT_FOUND_PAGE: '/error/not-found',
  GAQ_API_ERROR_PAGE:`${GET_A_QUOTE_URL}/api-error`,
  GET_A_QUOTE: GET_A_QUOTE_URL,
  QUOTE_ACCEPTANCE: `${GET_A_QUOTE_URL}/Quote-Acceptance?quoteId=#{quoteId}`,
  JOIN_NOW: JOIN_NOW_URL,
  MEMBERSHIP_STATUS: `${JOIN_NOW_URL}/Membership-Status`,
  PAYMENT_STATUS: `${JOIN_NOW_URL}/Payment-Status`,
  MEMBER_PORTAL: '/portal',
  MEMBER_PORTAL_LOGIN_PAGE: '/MemberPortal/GetRequestSignInOpenIdConnect?returnURL=%2Fportal',
  CONTACT_US: '/Support/Contact-Us',
  CONTACT_US_CONFIRMATION: '/support/contact-us/confirmation',
  MAINTENANCE_DATA: '/api/home/maintenance-reference-data',
});

export default PageURLs;
